import {Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {FavoriteShape, FavoriteShapeStatus, Formes} from 'src/app/classes/json-interface';
import {CLineDec} from 'src/app/classes/decorticage/info-decorticage';
import {ArmaServServerMethods} from '../../../classes/ArmaServServerMethods';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {ArmaServConnection} from 'src/app/classes/info-connection';
import {HttpClient} from '@angular/common/http';
import {AppToolbarService} from '../../toolbar/services/app-toolbar.service';
import {CUtilForme} from '../../../classes/info-forme';

interface ModalData {
  FavoriteShapes: FavoriteShape[];
}

interface InputShape {
  value: string;
  viewValue: string;
}

@Component({
  templateUrl: './dialogShapeSearch.html',
  styleUrls: ['./dialogShapeSearch.css']
})
// tslint:disable-next-line:component-class-suffix
export class DialogShapeSearch implements OnInit { //TODO: Duplication avec shapecomponent :(
  HTML_TABLE_HEADER_COL: string[] = ['SHAPE', 'Action'];
  HTML_TABLE_DATASOURCE: MatTableDataSource<Formes>;
  mArrayFavoriteShape: FavoriteShape[] = [];

  public HTML_INPUT_FILTER: string = '';
  public HTML_INPUT_PLIURE: string = 'any';
  mSiteCode: string = '';

  @ViewChild('table', { static: false }) mTable!: MatTable<any>;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild('scroll', {static: true}) mDivMainContent!: ElementRef<HTMLDivElement>;


  public mInput: InputShape[] = [
    {value: 'any', viewValue: 'Any'},
    {value: '0', viewValue: '0'},
    {value: '1', viewValue: '1'},
    {value: '2', viewValue: '2'},
    {value: '3', viewValue: '3'},
    {value: '4', viewValue: '4'},
    {value: '5', viewValue: '5'},
    {value: '6', viewValue: '6'},
    {value: '7', viewValue: '7'},
    {value: '8', viewValue: '8'},
    {value: '9', viewValue: '9'},
    {value: '10', viewValue: '10'},
    {value: '11', viewValue: '11'},
    {value: '12', viewValue: '12'},
    {value: '13', viewValue: '13'},
    {value: '14', viewValue: '14'},
    {value: '15', viewValue: '15'},
    {value: '16', viewValue: '16'},
    {value: '17', viewValue: '17'},
    {value: '18', viewValue: '18'},
    {value: '19', viewValue: '19'},
    {value: '20', viewValue: '20'},
  ];

  /*

  */
  public static async openDialog(matDialog: MatDialog, favoriteShapes: FavoriteShape[]): Promise<CLineDec|false> {
    const modalData: ModalData = {
      FavoriteShapes: favoriteShapes
    };
    const dialogParamRef = matDialog.open(DialogShapeSearch, {
      width: '950px',
      height: '90%',
      data: modalData
    });
    return dialogParamRef.afterClosed().toPromise();
  }

  constructor(
    public mDialogRef: MatDialogRef<DialogShapeSearch>,
    @Inject(MAT_DIALOG_DATA) modalData: ModalData,
    private mArmaServMethods: ArmaServServerMethods,
    private mHttp: HttpClient,
    private mToolBar: AppToolbarService
  ) {
    this.HTML_TABLE_DATASOURCE = new MatTableDataSource<Formes>([]);
    this.mSiteCode = mToolBar.selectedSiteCode;
    this.mArrayFavoriteShape = modalData.FavoriteShapes;
    return;
  }

  async ngOnInit(): Promise<void> {
    // On charge les formes du catalogue du chantier (avec le NbPlis etc.. qu'on ne charge pas dans le décorticage)
    const result = (await ArmaServConnection.aGET(this.mHttp, 'GetAvailableShapeFromSite', [this.mSiteCode])).result[0];
    this.HTML_TABLE_DATASOURCE.data = result.shapes;
    this.HTML_TABLE_DATASOURCE.paginator = this.paginator;
    console.log(this.mArrayFavoriteShape);
    this.HTML_TABLE_DATASOURCE.filterPredicate = (data: Formes, filter: any) => {

      function checkCodeForme(search: boolean, _filter: string, currentValue: any): boolean {
        if (search && _filter && _filter !== '' ) {
          const m = currentValue.match(_filter);
          search = m && m.length > 0;
        }
        return search;
      }

      function checkSelectQty(search: boolean, _filter: any, currentValue: any) {
        if (search && _filter && _filter !== 'any')
          search = _filter == currentValue;
        return search;
      }

      let boolCheckFilterSearch = true; //recherche pour any
      boolCheckFilterSearch = checkCodeForme(boolCheckFilterSearch, this.HTML_INPUT_FILTER, data.CodeForme);
      boolCheckFilterSearch = checkSelectQty(boolCheckFilterSearch, this.HTML_INPUT_PLIURE, data.NbPliure);
      return boolCheckFilterSearch;
    };
  }

  onDialogBtnClick(result: String) {
    this.mDialogRef.close();
  }

  onKeyCodeDown(event: KeyboardEvent) {
    if (event.key === ' ') return true;
    const regex = new RegExp('^[a-zA-Z0-9]+$');
    if (!regex.test(event.key)) {
      event.preventDefault();
      return false;
    }
  }

  getIndexShapeFavorite(noForme: number): number {
    const indexFavorite: number = this.mArrayFavoriteShape.map((value) => value.NoForme).indexOf(noForme);
    return indexFavorite;
  }

  onFilterChange() {
    this.HTML_TABLE_DATASOURCE.filter = new Date().getTime().toString();
  }

  IsFavorite(shape: Formes): boolean {
    const indexFavorite: number = this.getIndexShapeFavorite(shape.CleForme);
    const favorite: boolean = indexFavorite != -1;
    // La forme est favorite si elle a le STATUS Favorite
    return favorite && this.mArrayFavoriteShape[indexFavorite].Status == FavoriteShapeStatus.Favorite;
  }

  private OnPropertiesChange(shape: Formes) {
    const indexFavoriteShape: number = this.getIndexShapeFavorite(shape.CleForme);
    let favoriteShape: FavoriteShape | undefined;
    if (indexFavoriteShape == -1) {
      favoriteShape = undefined;
    } else {
      favoriteShape = this.mArrayFavoriteShape[indexFavoriteShape];
      favoriteShape.Status = FavoriteShapeStatus.PanelVisible; // On enlève la notion favoris car pas de sens d'avoir une forme qui n'apparait pas dans la liste des formes en favoris
    }
    CUtilForme.UpdateShapeFavorite(this.mHttp, shape, favoriteShape);
  }

  private ToggleFavorite(event: Event, shape: Formes) {
    const indexFavorite: number = this.getIndexShapeFavorite(shape.CleForme);
    let favoriteShape: FavoriteShape;
    if (indexFavorite == -1) {
      favoriteShape = {NoForme: shape.CleForme, Status: FavoriteShapeStatus.Default, PanelVisible: true};
    } else {
      favoriteShape = this.mArrayFavoriteShape[indexFavorite];
    }

    // Si la forme est actuellement favorite
    if (favoriteShape.Status == FavoriteShapeStatus.Favorite) {
      if (shape.WebSelectable == 2) {
        favoriteShape.Status = FavoriteShapeStatus.PanelVisible;
      } else {
        favoriteShape.Status = FavoriteShapeStatus.Default;
        // Si le favoris existait, maintenant il n'y a plus de favoris pour cette forme, on la supprime de la liste (optionnel)
      }
    } else {
      favoriteShape.Status = FavoriteShapeStatus.Favorite;
      if (shape.WebSelectable == 2) {
        favoriteShape.PanelVisible = true;
      }
    }

    // Pas de favoris conçernant cette forme actuellement
    if (indexFavorite == -1) {
      this.mArrayFavoriteShape.push(favoriteShape);
    } else {
      this.mArrayFavoriteShape[indexFavorite] = favoriteShape;
    }

    CUtilForme.UpdateShapeFavorite(this.mHttp, shape, favoriteShape);

    //On empêche la propagation de l'event de click (Pour pas générer de click sur la forme mais bien sur le bouton favorit)
    event.stopPropagation();
  }

  getShapeFavoriteProperties(forme: Formes): FavoriteShape {
    const indexShape: number = this.getIndexShapeFavorite(forme.CleForme);
    let resultShape: FavoriteShape;
    if (indexShape == -1) {
      resultShape = {NoForme: forme.CleForme,
                    Status: FavoriteShapeStatus.PanelVisible,  // La forme n'est visible qu'en recherche
                    PanelVisible: false};
    } else {
      resultShape = this.mArrayFavoriteShape[indexShape];
    }
    return resultShape;
  }

  onPageChange() {

  }
}
